export default {"group":"tag-group-module__group___YM2O0","group-title":"tag-group-module__group-title___53F8o","group-counter":"tag-group-module__group-counter___Zm-7t"}
import '/home/jenkins/agent/workspace/_release_release_t3-widgets_15.1/packages/common/widgets/src/components/tag/tag-group.module.css'
